var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMdiBathroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 52,
    viewBox: "0 0 50 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.75 30.3362V32.438C43.75 36.4524 41.5208 39.9413 38.2292 41.7068L39.5833 47.1504H35.4167L34.375 42.9468H15.625L14.5833 47.1504H10.4167L11.7708 41.7068C10.1025 40.8139 8.70688 39.4792 7.73414 37.8461C6.7614 36.213 6.24829 34.3433 6.24999 32.438V30.3362H4.16666V26.1327H41.6667V11.4203C41.6667 10.8629 41.4472 10.3283 41.0565 9.93412C40.6658 9.53997 40.1359 9.31853 39.5833 9.31853C38.5417 9.31853 37.75 10.0331 37.5 10.9789C38.8125 12.1139 39.5833 13.7953 39.5833 15.6238H27.0833C27.0833 13.9516 27.7418 12.3478 28.9139 11.1653C30.086 9.98284 31.6757 9.31853 33.3333 9.31853H33.6875C34.5417 6.88048 36.8542 5.11499 39.5833 5.11499C41.2409 5.11499 42.8306 5.7793 44.0027 6.96177C45.1748 8.14425 45.8333 9.74803 45.8333 11.4203V30.3362H43.75ZM39.5833 30.3362H10.4167V32.438C10.4167 34.1103 11.0751 35.714 12.2472 36.8965C13.4193 38.079 15.0091 38.7433 16.6667 38.7433H33.3333C34.9909 38.7433 36.5806 38.079 37.7527 36.8965C38.9248 35.714 39.5833 34.1103 39.5833 32.438V30.3362Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiBathroom);
export default __webpack_public_path__ + "static/media/mdi_bathroom.d9c81a9d5984ab3f27a6ac7ce9aa138a.svg";
export { ForwardRef as ReactComponent };